/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCos } from '../../factoriesAny.js';
export var cosDependencies = {
  typedDependencies,
  createCos
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesCos.generated.js
// module id = bQ0R
// module chunks = 3